module.exports = __webpack_public_path__ + "static/img/A43.d6798f75.jpg";